/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

//import axios from '@/axios.js';
import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/firestore';
//import router from '@/router';
import moment from "moment-timezone";
import _ from 'lodash';
import axios from 'axios';
export default {
  fetchUsersRoulet ({ commit },{datestart,dateend}) {
    return new Promise( async (resolve) => {
      commit('SET_ROULET', []);
        const users = []; 
        await firebase.database().ref().child('users').orderByChild('calculate').equalTo('Y').once('value', async (snapshot) => {
          snapshot.forEach((data) => {
            users[data.val().userId] = data.val();
          });
        });
        const spin = [];
        await firebase.firestore().collection('roulet').where('createdate','>=',datestart+' 00:00:00').where('createdate','<=',dateend+' 23:59:59').get().then((snapshot)=>{
          snapshot.forEach((doc) => {
            const data = doc.data();
            if(users[data.userId]){
              data.firstname = users[data.userId].firstname;
              data.lastname = users[data.userId].lastname;
              data.code = users[data.userId].code;
              data.pictureUrl = users[data.userId].pictureUrl;
              spin.push(data);
            }
          });
          commit('SET_ROULET', spin);
        });
        resolve(true)
    });
  },
  fetchUsersSpin ({ commit },{datestart,dateend}) {
    return new Promise( async (resolve) => {
      commit('SET_SPIN', []);
        const users = []; 
        await firebase.database().ref().child('users').orderByChild('calculate').equalTo('Y').once('value', async (snapshot) => {
          snapshot.forEach((data) => {
            users[data.val().userId] = data.val();
          });
        });
        const spin = [];
        await firebase.firestore().collection('spin').where('createdate','>=',datestart+' 00:00:00').where('createdate','<=',dateend+' 23:59:59').get().then((snapshot)=>{
          snapshot.forEach((doc) => {
            const data = doc.data();
            if(users[data.userId]){
              data.firstname = users[data.userId].firstname;
              data.lastname = users[data.userId].lastname;
              data.code = users[data.userId].code;
              data.pictureUrl = users[data.userId].pictureUrl;
              spin.push(data);
            }
          });
          commit('SET_SPIN', spin);
        });
        resolve(true)
    });
  },
  fetchUsersAdmin ({ commit },{datestart,dateend}) {
    return new Promise( async (resolve) => {
      commit('SET_SPIN', []);
        const users = []; 
        await firebase.database().ref().child('users').orderByChild('calculate').equalTo('Y').once('value', async (snapshot) => {
          snapshot.forEach((data) => {
            users[data.val().userId] = data.val();
          });
        });
        const spin = [];
        await firebase.firestore().collection('adminkindness').where('createdate','>=',datestart+' 00:00:00').where('createdate','<=',dateend+' 23:59:59').get().then((snapshot)=>{
          snapshot.forEach((doc) => {
            const data = doc.data();
            if(users[data.userId]){
              data.firstname = users[data.userId].firstname;
              data.lastname = users[data.userId].lastname;
              data.code = users[data.userId].code;
              data.pictureUrl = users[data.userId].pictureUrl;
              spin.push(data);
            }
          });
          commit('SET_ADMIN', spin);
        });
        resolve(true)
    });
  },
  fetchUsersRedeem ({ commit },{datestart,dateend}) {
    return new Promise( async (resolve) => {
      commit('SET_REDEEMS', []);
        const users = []; 
        await firebase.database().ref().child('users').orderByChild('calculate').equalTo('Y').once('value', async (snapshot) => {
          snapshot.forEach((data) => {
            users[data.val().userId] = data.val();
          });
        });
        const rewards = []; 
        await firebase.database().ref().child('rewards').once('value', async (snapshot) => {
          snapshot.forEach((data) => {
            rewards[data.key] = data.val();
          });
        });
        const redeems = [];
        await firebase.firestore().collection('redeemreward').where('createdate','>=',datestart+' 00:00:00').where('createdate','<=',dateend+' 23:59:59').get().then((snapshot)=>{
          snapshot.forEach((doc) => {
            const data = doc.data();
            if(users[data.userId] && rewards[data.rewardId]){
              data.firstname = users[data.userId].firstname;
              data.lastname = users[data.userId].lastname;
              data.code = users[data.userId].code;
              data.rewardname = 'ใช้ '+data.coin+' แลก '+data.credit+' เครดิต';
              data.pictureUrl = users[data.userId].pictureUrl;
              redeems.push(data);
            }
          });
          commit('SET_REDEEMS', redeems);
        });
        resolve(true)
      
    });
  },
  fetchUsers ({ commit },{datestart,dateend}) {
    return new Promise( async (resolve) => {
      commit('SET_USERS', []);
      const promise1 = new Promise(async (resolve) => {
        const deposit = [];
        await firebase.firestore().collection('krungsri').where('createdate','>=',datestart+' 00:00:00').where('createdate','<=',dateend+' 23:59:59').where('status','==','ดำเนินการแล้ว').get().then((snapshot)=>{
          snapshot.forEach((doc) => {
            if(doc.data().userId){
              if(!deposit[doc.data().userId]){
                deposit[doc.data().userId] = 0;
              }
              deposit[doc.data().userId] += Number(doc.data().qty.toString().replace(/,/g,''));
            }
          });
        });
        resolve(deposit);
      });
      const promise2 = new Promise(async (resolve) => {
        const withdraw = [];
        await firebase.firestore().collection('history').where('createdate','>=',datestart+' 00:00:00').where('createdate','<=',dateend+' 23:59:59').where('status','==','ดำเนินการแล้ว').where('type','==','ถอน').get().then((snapshot)=>{
          snapshot.forEach((doc) => {
            if(!withdraw[doc.data().userId]){
              withdraw[doc.data().userId] = 0;
            }
            withdraw[doc.data().userId] += Number(doc.data().qty.toString().replace(/,/g,''));
          });
        });
        resolve(withdraw);
      });
      const promise3 = new Promise(async(resolve) => {
        const bonus = [];
        await firebase.firestore().collection('history').where('createdate','>=',datestart+' 00:00:00').where('createdate','<=',dateend+' 23:59:59').where('status','==','ดำเนินการแล้ว').where('type','==','ฝาก').get().then((snapshot)=>{
          snapshot.forEach((doc) => {
            if(doc.data().bonus>0){
              if(!bonus[doc.data().userId]){
                bonus[doc.data().userId] = 0;
              }
              bonus[doc.data().userId] += Number(doc.data().bonus.toString().replace(/,/g,''));
            }
          });
        });
        await firebase.firestore().collection('santaclaus').where('createdate', '>=', datestart + ' 00:00:00').where('createdate', '<=', dateend + ' 23:59:59').get().then((snapshot) => {
          snapshot.forEach((doc) => {
              if (doc.data().value > 0) {
                if(!bonus[doc.data().userId]){
                  bonus[doc.data().userId] = 0;
                }
                bonus[doc.data().userId] += Number(doc.data().value.toString().replace(/,/g,''));
              }
          });
        });
        await firebase.firestore().collection('redeemreward').where('createdate', '>=', datestart + ' 00:00:00').where('createdate', '<=', dateend + ' 23:59:59').get().then((snapshot) => {
            snapshot.forEach((doc) => {
                if (doc.data().credit > 0) {
                  if(!bonus[doc.data().userId]){
                    bonus[doc.data().userId] = 0;
                  }
                  bonus[doc.data().userId] += Number(doc.data().credit.toString().replace(/,/g,''));
                }
            });
        });
        await firebase.firestore().collection('roulet').where('createdate', '>=', datestart + ' 00:00:00').where('createdate', '<=', dateend + ' 23:59:59').get().then((snapshot) => {
            snapshot.forEach((doc) => {
                if (doc.data().value > 0) {
                  if(!bonus[doc.data().userId]){
                    bonus[doc.data().userId] = 0;
                  }
                  bonus[doc.data().userId] += Number(doc.data().value.toString().replace(/,/g,''));
                }
            });
        });
        await firebase.firestore().collection('waste').where('createdate', '>=', datestart + ' 00:00:00').where('createdate', '<=', dateend + ' 23:59:59').get().then((snapshot) => {
          snapshot.forEach((doc) => {
              if (doc.data().waste > 0) {
                if(!bonus[doc.data().userId]){
                  bonus[doc.data().userId] = 0;
                }
                bonus[doc.data().userId] += Number(doc.data().waste.toString().replace(/,/g,''));
              }
          });
        });
        await firebase.firestore().collection('sharefriend').where('createdate', '>=', datestart + ' 00:00:00').where('createdate', '<=', dateend + ' 23:59:59').get().then((snapshot) => {
          snapshot.forEach((doc) => {
              if (doc.data().value > 0) {
                if(!bonus[doc.data().userId]){
                  bonus[doc.data().userId] = 0;
                }
                bonus[doc.data().userId] += Number(doc.data().value.toString().replace(/,/g,''));
              }
          });
        });
        resolve(bonus);
      });
      Promise.all([promise1, promise2, promise3]).then((values) => {
        firebase.database().ref().child('users').orderByChild('calculate').equalTo('Y').once('value', async (snapshot) => {
          let users = []; 
          snapshot.forEach((data) => {
            const user = data.val();
            if(values[0][user.userId] || values[1][user.userId] || values[2][user.userId]){
              user.key = data.key;
              user.bonus = (values[2][user.userId])?values[2][user.userId]:0;
              user.deposit = (values[0][user.userId])?values[0][user.userId]:0;
              user.withdraw = (values[1][user.userId])?values[1][user.userId]:0;
              users.push(user);
            }
          });
          users = _.orderBy(users, ['deposit'],['desc']);
          //users = _.orderBy(users, ['createdate'],['desc']);
          commit('SET_USERS', users);
          resolve(true)
        });
      });
    });
  },
  fetchUsers5 ({ commit },{datestart,dateend,web}) {
    return new Promise( async (resolve) => {
      commit('SET_USERS', []);
      const start = datestart+' 00:00:00';
      const end = dateend.split('-');
      firebase.database().ref().child('redeems').orderByChild('createdate').startAt(start).once('value', async (snapshot) => {
        const users = [];
        const datee = end[0]+''+end[1]+''+end[2]+'235959';
        snapshot.forEach((val)=>{
          console.log(web);
          console.log(val.val().web);
          if((web && val.val().web === web) || web == ''){
            const cd = val.val().createdate.split(' ');
            const date = cd[0].split('-');
            const time = cd[1].split(':');
            const createdate = date[0]+''+date[1]+''+date[2]+''+time[0]+''+time[1]+''+time[2];
            console.log(datee,createdate);
            if(+createdate <= +datee)
            users.push(val.val());
          }
        });
        commit('SET_USERS', users);
        resolve(true)
      });
      
    });
  },
  setStatus({ commit,state,rootState },key) {
    const {users} = state;
    for(const x in users){
      if(users[x].key === key){
        users[x].status = 'Yes';
        firebase.firestore().collection('waste').doc(key).set({
          userId:users[x].userId,
          waste:users[x].waste,
          createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
          wastedate:moment().tz("Asia/Bangkok").format("DD MMM YYYY"),
          employee:rootState.AppActiveUser,
          deopsit:users[x].deposit,
          withdraw:users[x].withdraw,
        }).then(()=>{
          axios({
            method: "get",
            url: "https://api.superpgslot.com/waste/"+key,
          }).then(async response => {
              console.log(response);
          });
        });
        break;
      }
    }
    commit('SET_USERS', []);
    setTimeout(() => {
      commit('SET_USERS', users);
    }, 500);

  }
}
